import { PasswordModal } from '@/scripts/optional/password-modal'
import { safeDefineElement } from '@/scripts/core/global'
safeDefineElement(PasswordModal)
